var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "no-gutters",
      class: {
        row: _vm.row
      }
    },
    [
      typeof _vm.label !== "undefined" && _vm.label !== null
        ? _c("div", { staticClass: "col-sm-12 col-md-4 text-sentence" }, [
            _vm._v(_vm._s(_vm.label) + "\n    ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          class: {
            "col-sm-12 col-md-8":
              typeof _vm.label !== "undefined" && _vm.label !== null && _vm.row,
            col:
              (typeof _vm.label == "undefined" && _vm.row) ||
              (_vm.label == null && _vm.row)
          }
        },
        [
          _c("div", { staticClass: "switch" }, [
            _c(
              "label",
              {
                directives: [
                  {
                    name: "tooltips-enabled",
                    rawName: "v-tooltips-enabled",
                    value: {
                      active: _vm.tooltip,
                      title: _vm.title
                    },
                    expression:
                      "{\n                    active:tooltip,\n                    title:title\n                }"
                  }
                ]
              },
              [
                _c("span", { staticClass: "text-sentence" }, [
                  _vm._v(_vm._s(_vm.switch_off))
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.input_value,
                      expression: "input_value"
                    }
                  ],
                  attrs: {
                    tabindex: _vm.tabindex,
                    type: "checkbox",
                    name: _vm.field
                  },
                  domProps: {
                    checked: _vm.checked,
                    checked: Array.isArray(_vm.input_value)
                      ? _vm._i(_vm.input_value, null) > -1
                      : _vm.input_value
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.input_value,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.input_value = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.input_value = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.input_value = $$c
                      }
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "lever" }),
                _vm._v(" "),
                _c("span", { staticClass: "text-sentence" }, [
                  _vm._v(_vm._s(_vm.switch_on))
                ])
              ]
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1dd6422c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1dd6422c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./app/Shared/Resources/Assets/js/components/base/BaseSwitch.vue
// module id = 713
// module chunks = 0